exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/components/modelRow/ModelRow.scss
 ** module id = 149
 ** module chunks = 0
 **/